import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import useUserData from 'data-hooks/useUserData';
import CustomerDashboardNavLinksUI from './CustomerDashboardNavLinksUI';
const CustomerDashboardNavLinks = t0 => {
  const $ = _c(6);
  const {
    items: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  const {
    pathname
  } = useLocation();
  const {
    isTradeUser
  } = useUserData();
  let t3;
  if ($[2] !== isTradeUser || $[3] !== items || $[4] !== pathname) {
    t3 = <CustomerDashboardNavLinksUI items={items} currentPath={pathname} showQuoteLink={isTradeUser} />;
    $[2] = isTradeUser;
    $[3] = items;
    $[4] = pathname;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
CustomerDashboardNavLinks.propTypes = {
  items: PropTypes.shape({
    label: PropTypes.string,
    path: PropTypes.string
  })
};
export default CustomerDashboardNavLinks;